(function () {

  // Intercept add-to-cart forms on collection pages
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList.contains('cl-card__form')) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var variantInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    if (!variantInput || !variantInput.value) return;

    var variantId = variantInput.value;
    var quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

    var card = form.closest('.cl-card');
    var titleEl = card ? card.querySelector('.cl-card__title') : null;
    var productTitle = titleEl ? titleEl.textContent.trim() : 'Item';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status && data.status >= 400) {
          showNotification(data.description || 'Could not add to bag', true);
          return;
        }
        updateCartCount();
        animateCartIcon();
        showNotification(productTitle, false);
      })
      .catch(function () {
        showNotification('Something went wrong', true);
      });
  }, true); // use capture phase so we run before Dawn's handlers

  // ── Cart count update ─────────────────────────────────────
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
          el.innerHTML = '<span aria-hidden="true">' + count + '</span><span class="visually-hidden">' + count + ' items</span>';
        });
      });
  }

  // ── Cart icon bounce ──────────────────────────────────────
  function animateCartIcon() {
    var icon = document.querySelector('.header__icon--cart');
    if (!icon) return;
    icon.classList.remove('cart-icon--bump');
    void icon.offsetWidth;
    icon.classList.add('cart-icon--bump');
    setTimeout(function () { icon.classList.remove('cart-icon--bump'); }, 600);
  }

  // ── Notification bar ──────────────────────────────────────
  function showNotification(productTitle, isError) {
    // Remove any existing notification
    var existing = document.getElementById('ajax-notif');
    if (existing) {
      clearTimeout(existing._timer);
      existing.remove();
    }

    var bar = document.createElement('div');
    bar.id = 'ajax-notif';

    // Measure header height so notification sits just below it
    var headerEl = document.querySelector('.section-header');
    var headerHeight = headerEl ? headerEl.getBoundingClientRect().height : 0;

    // Apply styles inline so nothing can override them
    Object.assign(bar.style, {
      position: 'fixed',
      top: headerHeight + 'px',
      left: '0',
      right: '0',
      background: isError ? '#333' : '#000',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '1rem',
      padding: '1rem 2rem',
      zIndex: '999999',
      fontFamily: '-apple-system, "Helvetica Neue", Arial, sans-serif',
      fontSize: '1.1rem',
      letterSpacing: '0.05em',
      transform: 'translateY(-100%)',
      transition: 'transform 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
      boxSizing: 'border-box'
    });

    var msg = document.createElement('span');
    msg.style.cssText = 'font-weight:700;text-transform:uppercase;flex:1;';
    msg.textContent = isError ? productTitle : 'Added to bag — ' + productTitle;
    bar.appendChild(msg);

    if (!isError) {
      var actions = document.createElement('div');
      actions.style.cssText = 'display:flex;gap:0.8rem;flex-shrink:0;';

      var continueBtn = document.createElement('button');
      continueBtn.type = 'button';
      continueBtn.textContent = 'CONTINUE SHOPPING';
      continueBtn.style.cssText = 'background:transparent;color:#fff;border:1px solid rgba(255,255,255,0.4);font-family:inherit;font-size:1rem;font-weight:700;letter-spacing:0.05em;padding:0.5rem 1.2rem;cursor:pointer;text-transform:uppercase;';
      continueBtn.addEventListener('click', function () { dismiss(bar); });

      var viewBtn = document.createElement('a');
      viewBtn.href = '/cart';
      viewBtn.textContent = 'VIEW BAG';
      viewBtn.style.cssText = 'background:#fff;color:#000;border:1px solid #fff;font-family:inherit;font-size:1rem;font-weight:700;letter-spacing:0.05em;padding:0.5rem 1.2rem;cursor:pointer;text-transform:uppercase;text-decoration:none;display:inline-flex;align-items:center;';

      actions.appendChild(continueBtn);
      actions.appendChild(viewBtn);
      bar.appendChild(actions);
    }

    document.body.appendChild(bar);

    // Slide in
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        bar.style.transform = 'translateY(0)';
      });
    });

    // Auto-dismiss after 6s
    bar._timer = setTimeout(function () { dismiss(bar); }, 6000);
  }

  function dismiss(bar) {
    if (!bar || !bar.parentNode) return;
    clearTimeout(bar._timer);
    bar.style.transform = 'translateY(-100%)';
    setTimeout(function () { if (bar.parentNode) bar.parentNode.removeChild(bar); }, 350);
  }

})();
